// import axios from "../lib/axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "tailwindcss/tailwind.css";
import instance from "../lib/axios";

const NavbarTop = () => {
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const response = await instance.get("/api/currencies/");
      // console.log(response);

      if (response.data && Array.isArray(response.data.currencies)) {
        setCurrencies(response.data.currencies);
      } else {
        setCurrencies([]);
      }
    } catch (err) {
      console.error("Error fetching currencies:", err);
      setCurrencies([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="bg-white text-black text-sm py-[0.62rem] overflow-hidden whitespace-nowrap fixed z-[999]">
      <div className="scrolling-container">
        <div className="scrolling-content">
          {loading ? (
            // <span className="text-black">Loading currency data...</span>
            <span>{''}</span>
          ) : currencies.length > 0 ? (
            currencies.map((currency, index) => (
              <span
                key={index}
                className="flex items-center space-x-2 px-4 text-[#000] text-[Figtree] text-[0.625rem] font-normal leading-[0.8125rem]"
              >
                <img
                  src={currency.image || "/default-flag.png"}
                  alt={`${currency.currency} Flag`}
                  className="w-4 h-4"
                />
                <span>
                  {currency.name} ({currency.currency}):{" "}
                  <span className="font-bold">{currency.rate.toFixed(4)}</span>
                </span>
              </span>
            ))
          ) : (
            <span>No currency data available</span>
          )}
        </div>
      </div>
    </div>
  );
};

const NavbarMain = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate(); // React Router navigation
  const isMenuOpen = showDropdown || showMenu;

  const services = [
    { name: "Forex Cards", path: "/forex-cards" },
    { name: "Currency Exchange", path: "/exchange" },
    { name: "Remittance", path: "/nimo-remittance" },
    { name: "Corporate Solution", path: "/corporate-solutions" },
  ];

  return (
    <div>
      {/* Navbar */}
      <nav className="bg-[#DC143C] text-[#F4F2E8] px-6 py-2 md:px-[4.5rem] md:py-0 flex justify-between items-center w-full fixed mt-8 z-[9999]">
        <div className="flex items-center gap-4">
          {/* Three dots menu */}
          <div
            className="md:hidden cursor-pointer"
            onClick={() => setShowMenu(!showMenu)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="14"
              viewBox="0 0 16 14"
              fill="none"
            >
              <path
                d="M0 0H16V1.75H0V0ZM0 6.125H10.6667V7.875H0V6.125ZM0 12.25H16V14H0V12.25Z"
                fill="white"
              />
            </svg>
          </div>
          <div>
            <Link to="/">
              <img src="/assets/NimoLogo.svg" alt="logo" className="w-16 md:w-24" />
            </Link>
          </div>
        </div>

        {/* buttons for mobile */}
        <div className="flex gap-4 md:hidden">
          <button className="bg-white text-[#404040] text-[0.572rem] md:text-[0.9375rem] px-4 py-2 font-medium md:rounded-md rounded-[0.22881rem]">
            Get Started
          </button>
          <button className="bg-white text-[#404040] text-[0.572rem] md:text-[0.9375rem] px-4 py-2 font-medium md:rounded-md rounded-[0.22881rem]">
            Login
          </button>
        </div>

        <div className="hidden relative md:flex gap-[1.6rem] items-center ">
          <Link
            to="/"
            className="text-[#F4F2E8] text-[0.9375rem] font-medium leading-[1.25rem]"
          >
            Home
          </Link>
          <div
            // className="relative"
            onMouseEnter={() => setShowDropdown(true)}
            onMouseLeave={() => setShowDropdown(false)}
          >
            <div className="hover:bg-[rgba(246,104,132,0.30)] py-[0.625rem] px-[1.98rem] rounded-[0.1875rem] my-4">
              <button className="text-[#F4F2E8] text-[0.9375rem] font-medium leading-[1.25rem]">Services</button>
            </div>

            {showDropdown && (
              <div
                className="absolute left-[10%] w-44 h-44 bg-white rounded-md p-[0.625rem] z-50 shadow-[0px_1px_10.4px_0px_rgba(220,20,60,0.50)]"
                onMouseEnter={() => setShowDropdown(true)}
                onMouseLeave={() => setShowDropdown(false)}
              >
                {services.map((service, index) => (
                  <button
                    key={index}
                    onClick={() => navigate(service.path)}
                    className="block w-full text-[0.875rem] font-medium text-left px-4 py-2 text-[#404040] leading-[1.25rem]"
                  >
                    {service.name}
                  </button>
                ))}
              </div>
            )}
          </div>
          <Link to={'/support'} className="text-[#F4F2E8] font-medium">
            Support
          </Link>
        </div>
        <div className="md:flex gap-5 hidden">
          <button className="bg-white text-[#404040] px-4 py-2 rounded-md font-medium">
            Get Started
          </button>
          <button className="bg-white text-[#404040] px-4 py-2 rounded-md font-medium">
            Login
          </button>
        </div>
      </nav>

      {showMenu && (
        <div
          className="fixed inset-0 bg-black bg-opacity-5 backdrop-blur-[0.7px] z-40"
          onClick={() => setShowMenu(false)}
        />
      )}

      {/* Mobile Full-Width Menu */}
      {showMenu && (
        <div className="fixed top-0 left-0 w-[60%] h-full bg-[#FFFDFD] z-50 p-6 shadow-[2px_4px_4px_rgba(0,0,0,0.1)]">
          <Link to="/">
            <img src="/assets/mobileLogo.png" alt="logo" className="w-14" />
          </Link>
          {/* Close Button */}
          <button
            className="absolute top-4 right-4 text-2xl"
            onClick={() => setShowMenu(false)}
          >
            <img src="/assets/CrossIcon.svg" alt="CrossIcon" className="w-8" />
          </button>

          {/* Menu Items */}
          <nav className="flex flex-col mt-8">
            <Link
              to="/"
              className="text-[#404040] text-[1rem] font-medium py-4 border-b border-[#F0F0F0]"
              onClick={() => setShowMenu(false)}
            >
              Home
            </Link>

            {/* Services Dropdown */}
            <div
              className="text-[#404040] text-[0.875rem] flex items-center justify-between font-medium py-4"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              {/* <button
                className=""
                onClick={() => setShowDropdown(!showDropdown)}
              > */}
              <div>Service</div>
              <div>
                {showDropdown ? (
                  <img src="/assets/CaretUp.png" alt="Arrow Up" className="" />
                ) : (
                  <img
                    src="/assets/CaretDown.png"
                    alt="Arrow Down"
                    className=""
                  />
                )}
              </div>
              {/* </button> */}
            </div>
            <div>
              {showDropdown && (
                <div className="ml-4 mt-2 flex flex-col mb-3">
                  {services.map((service, index) => (
                    <button
                      key={index}
                      onClick={() => {
                        navigate(service.path);
                        setShowMenu(false);
                      }}
                      className=" text-[#404040] text-[0.75rem] font-medium py-2 text-left"
                    >
                      {service.name}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/support"
              className="text-[#404040] text-[0.875rem] font-medium py-4 border-t border-[#F0F0F0]"
              onClick={() => setShowMenu(false)}
            >
              Support
            </Link>
          </nav>
        </div>
      )}
    </div>
  );
};

const NavBar = () => {
  return (
    <div className="w-full">
      <NavbarTop />
      <NavbarMain />
    </div>
  );
};

export default NavBar;
